import { useEffect, useState } from "react";
import Pagination from "react-bootstrap/Pagination";
import Table from "react-bootstrap/Table";
import PropTypes from "prop-types";
import { myId } from "../Pages/ResultTable";
import Form from "react-bootstrap/Form";
//import Select from "react-select";
import { IoClose } from "react-icons/io5";
import ExportJsonExcel from "js-export-excel";
import { FaRegFileExcel } from "react-icons/fa";

const initDataTable = {
  actualPage: 1,
  totalPages: 1,
  data: [],
  rowsPerPage: 50,
};

const TableDataByStore = ({ dataVentas, pais }) => {
  const [dataTable, setDataTable] = useState(initDataTable);
  const [dataComplete, setDataComplete] = useState([]);
  useEffect(() => {
    initDataComplete();
  }, [dataVentas]);
  useEffect(() => {
    if (dataComplete.length > 0) {
      const totalPages = Math.ceil(
        dataComplete?.length / dataTable.rowsPerPage
      );
      setDataTable({
        ...dataTable,
        totalPages,
        data: dataComplete.slice(0, dataTable.rowsPerPage),
      });
    }
  }, [dataComplete]);

  const initDataComplete = () => {
    const { dataAOMByStore, dataHANAByStore } = dataVentas;
    //dataAOMByStore.resultVentas.recordset
    const arrayVentasAOM = dataAOMByStore?.resultVentas?.recordset || [];
    const arrayNCAOM = dataAOMByStore?.resultNC?.recordset || [];
    //dataHANAByStore.ventas
    const arrayVentasHANA = dataHANAByStore?.ventas || [];
    const arrayNCHANA = dataHANAByStore?.nc || [];
    let arrayComplete = [];
    if(arrayVentasAOM.length>0){
    arrayVentasAOM.forEach((itemAOM) => {
      //const { monto, store_name, store_no, transacciones } = itemAOM;
      const storeNum = String(itemAOM.store_no).trim();
      const storeName = String(itemAOM.store_name).trim();
      const ventasAOM = itemAOM.transacciones;
      const montoVentasAOM = itemAOM.monto;
      const ncAOM =
        arrayNCAOM.find((item) => String(item.store_no).trim() === storeNum)
          ?.transacciones || "";
      const montoNCAOM =
        arrayNCAOM.find((item) => String(item.store_no).trim() === storeNum)
          ?.monto || "";
      //[0].U_SYS_ID_TDA_POS  //storeNum
      //checaremos si existe la tienda en el array de HANA
      //console.log("storeNum:...", storeNum);
      //console.log("String(item.U_SYS_ID_TDA_POS).trim():..",String(item.U_SYS_ID_TDA_POS).trim())
      const ventasHANA =
        arrayVentasHANA.find(
          (item) => Number(String(item.U_SYS_ID_TDA_POS).trim()) === Number(storeNum)
        )?.VENTAS || "";
      const montoVentasHANA =
        arrayVentasHANA.find(
          (item) => Number(String(item.U_SYS_ID_TDA_POS).trim()) === Number(storeNum)
        )?.MONTO || "";
      const ncHANA =
        arrayNCHANA.find(
          (item) => Number(String(item.U_SYS_ID_TDA_POS).trim()) === Number(storeNum)
        )?.VENTAS || "";
      const montoNCHANA =
        arrayNCHANA.find(
          (item) => Number(String(item.U_SYS_ID_TDA_POS).trim()) === Number(storeNum)
        )?.MONTO || "";
      const difVentas = Number(ventasAOM || "0") - Number(ventasHANA || "0");
      const difNC = Number(ncAOM || "0") - Number(ncHANA || "0");
      arrayComplete = [
        ...arrayComplete,
        {
          storeNum,
          storeName,
          ventasAOM,
          ncAOM,
          montoVentasAOM,
          montoNCAOM,
          ventasHANA,
          ncHANA,
          montoVentasHANA,
          montoNCHANA,
          difVentas: String(difVentas),
          difNC: String(difNC),
        },
      ];
    });
    }else if(arrayVentasHANA.length>0){
      arrayVentasHANA.forEach((itemHANA) => {
        //const { monto, store  } = itemHANA;
        const storeNum = String(itemHANA.U_SYS_ID_TDA_POS).trim();
        const storeName = String(itemHANA.WhsName).trim();
        const ventasAOM = "";
        const montoVentasAOM = "";
        const ncAOM = "";
        const montoNCAOM = "";
        const ventasHANA = itemHANA.VENTAS;
        const montoVentasHANA = itemHANA.MONTO;
        const ncHANA = arrayNCHANA.find(item=>Number(String(item.U_SYS_ID_TDA_POS).trim())===Number(storeNum))?.VENTAS||"";
        const montoNCHANA = arrayNCHANA.find(item=>Number(String(item.U_SYS_ID_TDA_POS).trim())===Number(storeNum))?.MONTO||"";
        const difVentas = Number(ventasAOM || "0") - Number(ventasHANA || "0");
        const difNC = Number(ncAOM || "0") - Number(ncHANA || "0");
        arrayComplete = [
            ...arrayComplete,
            {
                storeNum,
                storeName,
                ventasAOM,
                ncAOM,
                montoVentasAOM,
                montoNCAOM,
                ventasHANA,
                ncHANA,
                montoVentasHANA,
                montoNCHANA,
                difVentas: String(difVentas),
                difNC: String(difNC),
            },
        ];
    });
    }




    if (arrayComplete.length === arrayVentasAOM.length||arrayComplete.length === arrayVentasHANA.length) {
      setDataComplete(arrayComplete);
      //console.log("dataComplete:...", arrayComplete);
    }
  };

  const currencyFormatter = ({ currency, value }) => {
    if (isNaN(value)) return null;
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      minimumFractionDigits: 2,
      currency,
    });
    return formatter.format(value);
  };
  const handleClose = () => {
    console.log("handleClose...");
  };
  const handleChangeRowsPerPage = (e) => {
    console.log("e.target.value:...", e.target.value);
    const rowsPerPage = Number(e.target.value);
    const totalPages = Math.ceil(dataComplete?.length / rowsPerPage);
    const initReg = dataTable.actualPage * rowsPerPage - rowsPerPage;
    const endReg = dataTable.actualPage * rowsPerPage;
    setDataTable({
      ...dataTable,
      totalPages,
      rowsPerPage,
      data: dataComplete.slice(initReg, endReg),
    });
  };

  const exportConsult = (dataArray, nameFile) => {
    console.log("Exportaremos la consulta:..", dataArray);

    let columnWidthsArray = [];
    let keysLength = Object.keys(dataArray[0]).length;

    for (let i = 0; i <= keysLength; i++) {
      columnWidthsArray.push(15);
    }

    let option = {};

    option.fileName = nameFile;

    option.datas = [
      {
        sheetData: [...dataArray],
        sheetName: nameFile,
        sheetFilter: Object.keys(dataArray[0]),
        sheetHeader: Object.keys(dataArray[0]),
        columnWidths: [...columnWidthsArray],
      },
    ];

    let toExcel = new ExportJsonExcel(option); //new
    toExcel.saveExcel(); //guardando
    console.log("Ya deberia de existir el archivo:..", toExcel);
    /* setTimeout(() => {
      setLoading(false);
    }, 1000); */
    //setLoading(false);
  };
  const tableHeaders=[
    "Tienda",
    "Nombre",
    "Ventas AOM",
    "Monto Ventas AOM",
    "NC AOM",
    "Monto NC AOM",
    "Ventas SAP",
    "Monto Ventas SAP",
    "NC SAP",
    "Monto NC SAP",
    "Dif Ventas",
    "Dif NC",
  ]



  return (
    
<>
{dataComplete.length===0?<div className="alert alert-warning">No hay datos para mostrar: {pais}</div>:
<div className="">
      <div className="fs-3 m-2 d-flex  border bg-light rounded w-100">
        <div className="text-end w-50 ">Datos por tienda para: {pais}</div>
        <span
                  id="customersAOM"
                  onClick={() => exportConsult(dataComplete, `dataTiendas_${pais}`)}
                  className="ms-3 btn btn-outline-success"
                >
                  <FaRegFileExcel />
                </span>
        <div className="text-end w-50  pe-3 d-none">
          <span onClick={handleClose} className="btn btn-light fs-4">
            <IoClose />
          </span>
        </div>
      </div>

      <Table striped bordered hover responsive>
        <thead>
          <tr>
          {tableHeaders.map((header) => (
            <th
              key={myId()}
              className="bg-dark text-white opacity-75"
            >
              {header}
            </th>
          ))}
            
          </tr>
        </thead>
        <tbody>
          {dataTable.data.map((store) => (
            <tr key={myId()}>
              <td>{store.storeNum}</td>
              <td>{store.storeName}</td>
              <td>{store.ventasAOM}</td>
              <td>
                {currencyFormatter({
                  currency: "usd",
                  value: store.montoVentasAOM,
                })}
              </td>
              <td>{store.ncAOM}</td>
              <td>
                {currencyFormatter({
                  currency: "usd",
                  value: store.montoNCAOM,
                })}
              </td>
              <td>{store.ventasHANA}</td>
              <td>
                {currencyFormatter({
                  currency: "usd",
                  value: store.montoVentasHANA,
                })}
              </td>
              <td>{store.ncHANA}</td>
              <td>
                {currencyFormatter({
                  currency: "usd",
                  value: store.montoNCHANA,
                })}
              </td>
              <td
                className={
                  store.difVentas === "0"
                    ? "bg-success text-white opacity-75"
                    : "bg-danger text-white opacity-75"
                }
              >
                {store.difVentas}
              </td>
              <td
                className={
                  store.difNC === "0"
                    ? "bg-success text-white opacity-75"
                    : "bg-danger text-white opacity-75"
                }
              >
                {store.difNC}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <h3 className="text-center border my-2 py-2 bg-light fs-6">Número de Tiendas: {dataComplete.length}</h3>
      <Pagination className=" d-flex justify-content-center align-items-center w-100">
        <Pagination.First
          onClick={() => {
            setDataTable({
              ...dataTable,
              actualPage: 1,
              data: dataComplete.slice(0, dataTable.rowsPerPage),
            });
          }}
        />
        <Pagination.Prev
          onClick={() => {
            if (dataTable.actualPage === 1) return;
            setDataTable({
              ...dataTable,
              actualPage: dataTable.actualPage - 1,
              data: dataComplete.slice(
                (dataTable.actualPage - 2) * dataTable.rowsPerPage,
                (dataTable.actualPage - 1) * dataTable.rowsPerPage
              ),
            });
          }}
        />
        <Pagination.Item active>{dataTable.actualPage}</Pagination.Item>
        <Pagination.Ellipsis />
        <Pagination.Item>{dataTable.totalPages}</Pagination.Item>
        <Pagination.Next
          onClick={() => {
            if (dataTable.actualPage === dataTable.totalPages) return;
            setDataTable({
              ...dataTable,
              actualPage: dataTable.actualPage + 1,
              data: dataComplete.slice(
                dataTable.actualPage * dataTable.rowsPerPage,
                (dataTable.actualPage + 1) * dataTable.rowsPerPage
              ),
            });
          }}
        />
        <Pagination.Last
          onClick={() => {
            setDataTable({
              ...dataTable,
              actualPage: dataTable.totalPages,
              data: dataComplete.slice(
                (dataTable.totalPages - 1) * dataTable.rowsPerPage,
                dataTable.totalPages * dataTable.rowsPerPage
              ),
            });
          }}
        />

        <Form.Select
          style={{ width: "60px" }}
          className="m-1 p-1"
          name="rowsPerPage"
          onChange={handleChangeRowsPerPage}
          id=""
        >
          <option value="50">50</option>
          <option value="30">30</option>
          <option value="20">20</option>
        </Form.Select>
      </Pagination>
    </div>
}
    
    </>
  );
};

TableDataByStore.propTypes = {
  dataVentas: PropTypes.object.isRequired,
  pais: PropTypes.string.isRequired,
};

export default TableDataByStore;
